import { z } from "zod";

export const FeedbackFormSchema = z.object({
  type: z.coerce.number().min(0, {
    message: "Please select a feedback type.",
  }),
  message: z.string().min(6, {
    message: "Message must be at least 6 characters.",
  }),
});

export type FeedbackFormType = z.infer<typeof FeedbackFormSchema>;
